export default {
  filters: {},
  paginationOptions: {},
  inhabitantChanges: [],
  inhabitantChangeStatuses: [],
  inhabitantChangeSources: [],
  inhabitantChangeTypes: []
};
